
<h3 class="heading text-a-center d-b">Organization Hierarchy</h3>


<div class="p-t-20 text-a-center"> 
  <nz-radio-group [nzButtonStyle]="'solid'" [(ngModel)]="selectedHier">
    <label nz-radio-button nzValue="whole" selected (click)="updateData('whole')">Whole Org</label>
    <label nz-radio-button nzValue="my" (click)="updateData('Vertical')">My Vertical</label>
  </nz-radio-group>
</div>

<div class="m-t-40 m-b-100">
  <ng2-org-chart [topEmployee]="topEmployee"></ng2-org-chart>
</div>
